// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/switchMap';
// import 'rxjs/add/operator/debounceTime';
// import 'rxjs/add/operator/skip';
// import 'rxjs/add/operator/withLatestFrom';
// import 'rxjs/add/operator/first';
// import 'rxjs/add/operator/mergeMap';

import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as c from '../actions/companies.actions';

import { Api } from '../providers/api/api';

@Injectable()
export class CompaniesEffects {
  constructor(private actions$: Actions,
    private api: Api
  ) {
  }

  @Effect()
  FetchCompanies$: Observable<Action> = this.actions$
    .ofType(c.FETCH)
    .map((action: c.Fetch) => {
      return action.payload;
    })
    .switchMap((filter: object) => this.api.getCompanies(filter))
    .map(companies => {
      return new c.FetchSuccess(companies)
    }
    ).catch(() => of(new c.FuzzyFetchFailure('')));

  @Effect()
  FuzzyFetchCompanies$: Observable<Action> = this.actions$
    .ofType(c.FUZZY_FETCH)
    .filter((action: c.FuzzyFetch) => action.payload.length>=2)
    .map((action: c.FuzzyFetch) => {
      return action.payload;
    })
    .switchMap((searchTerm: string) => this.api.getCompaniesByFuzzySearch(searchTerm))
    .map(company => {
      return new c.FuzzyFetchSuccess(company)
    }
    ).catch(() => of(new c.FuzzyFetchFailure('')));

}



// WEBPACK FOOTER //
// ./src/effects/companies.effect.ts